"use client";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-4">
      <div className="text-center">
        <h2 className="text-lg font-semibold text-zinc-100">页面加载出错</h2>
        <p className="mt-1 text-sm text-zinc-500">
          {error.message || "未知错误，请重试"}
        </p>
      </div>
      <button
        type="button"
        onClick={reset}
        className="rounded-lg bg-emerald-600/90 px-4 py-2 text-sm font-medium text-white transition hover:bg-emerald-500"
      >
        重试
      </button>
    </div>
  );
}
